<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

const translaterStore = useTranslaterStore()

const getTranslate = computed(() => translaterStore.getTranslate)
</script>

<template>
    <div class="asw-logo">
        <router-link to="/" class="asw-logo__link">
            <img src="@/assets/images/asw-logo.png" class="asw-logo__link-img" alt="" />

            <span class="asw-logo__link-text">{{ getTranslate.APP_NAME }}</span>
        </router-link>
    </div>
</template>

<style lang="scss">
@use '@/assets/styles/scss/components/logo';
</style>
